import { Injectable } from "@angular/core";
import { LocalAnyConferenceStream } from "youm-lib/conference";
import { BaseList } from "./base-list";

@Injectable()
export class LocalConferenceStreamsListService extends BaseList<LocalAnyConferenceStream> {
  get streams() {
    return super.items;
  }

  get streams$() {
    return super.items$;
  }

  compare(
    item1: LocalAnyConferenceStream,
    item2: LocalAnyConferenceStream
  ): number {
    return item1.streamId.localeCompare(item2.streamId);
  }
}
